import { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import NiceModal from '@ebay/nice-modal-react';
import ApiModal from '/src/components/modal/ApiModal/ApiModal';

import datasetService from '/src/features/dataset/services/datasetService';
import statementService from '/src/features/dataset/services/statementService';
import worksheetService from '../../../services/worksheetService';
import { PageTable, Header } from '/src/layouts/page';

import StatementModal from '/src/features/dataset/components/modal/StatementModal/StatementModal'
import StatementTestModal from "/src/features/dataset/components/modal/StatementTestModal/StatementTestModal"
import StringTable from "/src/features/dataset/components/table/StringTable/StringTable"
import ImportStatementModal from '../../modal/ImportModal/ImportStatementModal'
import ImportWorksheetModal from '../../modal/ImportModal/ImportWorksheetModal'
import DeleteAllStatementModal from '/src/features/dataset/components/modal/DeleteAllStatementModal/DeleteAllStatementModal'
import Table from '/src/components/table';
import storage from '/src/utils/storage';
import IconButton from '/src/components/UI/Button/IconButton/IconButton';
import { env } from '../../../../../var/env';
import "./StatementTable.css"
import StatementColumnModal from '/src/features/dataset/components/modal/StatementColumnModal/StatementColumnModal';
import getCutToken from "/src/utils/getCutToken";
import { useToastDispatchContext } from '/src/layouts/toast/context/toastContext';
import hasPermission from '/src/utils/hasPermission';
import HoverHeaderPopup from "./HeaderHoverChart"

function StatementTable() {

    const { name } = useParams();
    const { getDataset } = datasetService;
    const { deleteStatement } = statementService;
    const { deleteColumn } = worksheetService;
    const { getColumns } = worksheetService
    const { datasets } = storage().get('company');
    const toast = useToastDispatchContext();
    const dataset = datasets.find(dataset => dataset.name === name);
    var isWorksheet = dataset.dataset_type_id == 3;
    const navigate = useNavigate();


    const columnCell = (column, canBeModified = true) => {
        return isWorksheet && canBeModified ?
            <div onClick={() => onClickEditModalColumn(column)} className="column_field_table_statement">
                <span className="column_field_table_statement" > {column.name}</span>
                <i className='fas fa-trash delete_column_button' onClick={(e) => { onClickDeleteColumn(column), e.stopPropagation() }}></i>
            </div> : column
    }
    const [columnsWorksheet, setColumnsWorksheet] = useState(null);
    const [refreshTable, setRefreshTable] = useState(false)

    // const rowsRef = useRef([]);
    // const allRowsRef = useRef([]);


    const [cells, setCells] = useState(isWorksheet ? [] :
        [
            {
                column: columnCell("LABEL"),
                name: 'label',
                sort: true,
                show: (value) => value
            },
            {
                column: columnCell("SENTENCES"),
                name: 'statements',
                show: (value) => <StringTable data={value} />
            },
            {
                column: columnCell("RESPONSES"),
                name: 'responses',
                show: (value) => <StringTable data={value} />
            },
        ]);

    //  const getDatasetByName = async (data) => {
    //     const result = await getDataset(decodeURI(name), data);

    //     if (result && result[0] && result[0].data) {
    //         rowsRef.current = result[0].data;
    //     }
    //     return result;
    // };

    // const getAllDatasetByName = async (data) => {

    //     let page = 1;
    //     let allRows = [];

    //     while (true) {

    //         const result = await getDataset(decodeURI(name), {
    //             ...data,
    //             page: page
    //         });

    //         if (!result || !result[0] || !result[0].data) break;

    //         const rows = result[0].data;
    //         allRows = [...allRows, ...rows];

    //         // stop when last page reached
    //         if (rows.length < result[0].per_page) break;

    //         page++;
    //     }

    //     allRowsRef.current = allRows;

    //     console.log("Total rows stored:", allRowsRef.current.length);

    //     return await getDataset(decodeURI(name), data);
    // };

    const setUpColumns = async () => {
        const [res, error] = await getColumns(dataset.id);
        if (error) {
            console.error(error)
            return;
        }
        let _columns = res.data.filter(column => column.deleted == false);
        _columns.unshift({ name: "ID", id: "id", canBeModified: false })

        // loadData = await getDatasetByName();
        // const loadData = await getAllDatasetByName();
        setCells(_columns.map(column => {
             
            return {
                column: column.canBeModified == false ? columnCell(column.name, false) : columnCell(column),

            //    column: (
            //         <HoverHeaderPopup column={column} rowsData={allRowsRef.current}>
            //             {column.canBeModified == false ? columnCell(column.name, false) : columnCell(column)}
            //         </HoverHeaderPopup>
            //     ),

                name: column.id,
                //sort: true, // dependra du type
                show: (value) => column.type == "text" ? <div style={{ marginRight: "15px" }}><StringTable data={value} /> </div>
                    :
                    (column.canBeModified == false ?
                        <span style={{ color: "var(--main)", cursor: "pointer" }} onClick={(e) => navigator.clipboard.writeText(value).then(_ => { toast.success('Copy token to clipboard', 'You can paste this token where you need !', 5000); })}>  {getCutToken(value)}</span>
                        :
                        (value &&
                            <span style={{ marginRight: "15px" }} title={value}>{value.toString().split(';').slice(0, 5).join(';') + (value.toString().split(';').slice(5).length > 5 ? "..." : "")}</span>
                        )
                    )
            }
        }))
        setColumnsWorksheet(res.data);
    }
    //const onClickAdd = ({ deleteRow, row }) => row.test = 'name' && console.log(row) && updateRow(row);

    const getDatasetByName = async (data) => {
        return getDataset(decodeURI(name), data);
    }

   


    const onClickEditModalColumn = async (column) => {
        await NiceModal.show(StatementColumnModal, {
            column: column,
            dataset: dataset,
        }).then(() => setUpColumns());
    }
    const onClickOpenModalColumn = async () => {
        await NiceModal.show(StatementColumnModal, {
            dataset: dataset,
        }).then(() => setUpColumns());
    }

    const onClickDelete = ({ row, deleteRow }) => {
        const { id, label } = row;

        NiceModal.show(ApiModal, {
            title: 'Delete Statement ',
            body: 'Do you really want to delete your statement ' + (label ?? "") + " ?",
            api: {
                request: deleteStatement,
                param: [name, id]
            },
            buttons: [
                { className: 'validate', label: 'Cancel', style: { marginRight: '20px' } },
                { className: 'cancel', label: 'Delete', type: 'submit' },
            ]
        }).then(() => { deleteRow(id) })
    };

    const onClickDeleteColumn = (column) => {

        NiceModal.show(ApiModal, {
            title: 'Delete Column ',
            body: 'Do you really want to delete the column ' + (column.name ?? "") + " ?",
            api: {
                request: deleteColumn,
                param: [name, { index: column.index }]
            },
            buttons: [
                { className: 'validate', label: 'Cancel', style: { marginRight: '20px' } },
                { className: 'cancel', label: 'Delete', type: 'submit' },
            ]
        }).then(() => setUpColumns())
    };

    const showEditModal = async ({ row, updateRow }) => {
        dataset.columns = columnsWorksheet;
        await NiceModal.show(StatementModal, {
            title: 'Your Statement',
            dataset: dataset,
            data: { ...row }
        }).then((statement) => updateRow(statement))
    }

    const showAddModal = ({ addRow }) => {
        dataset.columns = columnsWorksheet;
        NiceModal.show(StatementModal, {
            dataset: dataset,
            title: 'Add your Statement',
        }).then((statement) => addRow(statement))
    }

    const showTestModal = ({ addRow, row }) => NiceModal.show(StatementTestModal, {
        dataset: dataset,
        data: { ...row }
    }).then((statement) => addRow(statement))

    const refreshData = async () => {
        await setUpColumns();
        setRefreshTable(!refreshTable)
    }
    const showImportStatementModal = () => NiceModal.show(ImportStatementModal, { nameDataset: name }).then(() => { isWorksheet ? setUpColumns() : updateBoolState(!boolState) })

    const showImportWorksheetModal = () => NiceModal.show(ImportWorksheetModal, { nameDataset: name }).then(() => refreshData())

    //const showImportStopWordsModal = () => NiceModal.show(ImportStopWordsModal, { nameDataset: name })
    const showDeleteAllStatementModal = () => NiceModal.show(DeleteAllStatementModal, { nameDataset: name }).then(() => updateBoolState(!boolState))
    const actions = [
        { className: "fas fa-edit action-button edit_action", style: {}, onClick: showEditModal },
        { className: "fas fa-trash action-button delete_action", style: {}, onClick: onClickDelete },
    ];

    var actionExtension = isWorksheet ? <span><IconButton className={" action_dataset_extension"} icon={"fas fa-plus"} title={"Add a new column"} onClick={onClickOpenModalColumn}></IconButton></span> : false;
    var buttons = [
        { icon: "fas fa-plus", style: { margin: "0 10px" }, onClick: showAddModal },
    ];
    if (!isWorksheet) {
        buttons.push({ icon: "fas fa-rocket", style: { margin: "0 10px" }, onClick: showTestModal })
    }
    if (isWorksheet) {
        buttons.unshift({ icon: "fas fa-pie-chart", style: { margin: "0 10px" }, onClick: () => navigate(`/company/${storage('session').get('company').name}/datasets/${name}/statistics`) })
    }


    const filters = isWorksheet ? [
        { type: 'input', placeholder: 'terms', name: 'terms' }
    ] : [
        { type: 'input', placeholder: 'tag', name: 'label' }
    ]
    const url = env.REACT_APP_API_PATH + `/dataset/${name}/export?token_auth=${storage('local').get('token')}&company=${storage('session').get('company').id}`;

    const [boolState, updateBoolState] = useState(false);

    useEffect(() => {
        if (isWorksheet) {
            setUpColumns()
        }
    }, [name])
    return (
        <PageTable>
            <Header title={`Manage ${name} statements`}>
                <IconButton onClick={isWorksheet ? showImportWorksheetModal : showImportStatementModal} className=" icons_up main-iconButton profil_action main_add-button space_tableButton" icon="fas fa-upload" title="Import Statements"></IconButton>
                { /* <IconButton onClick={showImportStopWordsModal} className=" icons_up main-iconButton profil_action main_add-button space_tableButton" icon="fas fa-file-word" title="Import Stop-Words"></IconButton> */}
                <a href={url} rel="noopener noreferrer"><IconButton className=" icons_up main-iconButton profil_action main_add-button space_tableButton" icon="fas fa-download" title="Export Statements"></IconButton></a>
                {hasPermission('erase_all_raw_dataset') ?
                    <IconButton onClick={showDeleteAllStatementModal} className=" icons_up main-iconButton delete_action main_add-button space_tableButton red-button-action-bg_color" icon="fas fa-trash" title="Delete All Statements"></IconButton>
                    : null
                }
            </Header>
            {

                <Table name={isWorksheet ? "data" : "prompt"} plurial={!isWorksheet} cells={cells} api={getDatasetByName} actions={actions} buttons={buttons} filters={filters} actionExtension={actionExtension} refreshState={[refreshTable, setRefreshTable]}></Table>
            }
        </PageTable>
    );
}

export default StatementTable;
